<div class=" d-block d-lg-none">
    <app-h-profile></app-h-profile>
    
</div>



    <div class="row about-me">
        <div class="col-md-12 col-sm-12">
    <h5>
        I am an Assistant Professor of Economics at the University of Wisconsin-Whitewater. I completed my Ph.D. in Economics from the University of Illinois at Urbana-Champaign (May 2024). 
        <br>
        <hr>
 I am an applied microeconomist with research interests in public economics and labor economics. My research focuses on understanding the impact of programs that support low-income families and improve economic opportunities for underprivileged individuals.
    </h5>
    
        </div>
    </div>


<app-publications></app-publications>
<app-teaching></app-teaching>
<app-news></app-news>
